import { render } from "./ChangingHistoryPage.vue?vue&type=template&id=fd4ad178"
import script from "./ChangingHistoryPage.vue?vue&type=script&lang=js"
export * from "./ChangingHistoryPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__